import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
const DPharma=()=>{
    const progHiglight=[
{listName:'1. Why Choose a PCIApproved D. Pharmacy Course at MVN?'},
{listName:'Pursuing a Diploma in Pharmacy (D. Pharmacy) from a Pharmacy Council of India (PCI)approved institution like MVN ensures that students receive industry-relevant, regulation-compliant education that sets the foundation for a successful career in the pharmaceutical sector.'},
{listName:'2. Key Benefits of Studying D. Pharmacy at MVN:'},
{listName:'Regulatory Recognition - Our program is approved by the Pharmacy Council of India (PCI), ensuring national recognition and eligibility for registration as a pharmacist across India.'},
{listName:'Comprehensive Curriculum - Designed as per PCI guidelines, our curriculum blends theoretical knowledge with hands-on practical training to develop core competencies in: '},
{listName:'Pharmacology'},
{listName:'Pharmaceutics'},
{listName:'Pharmaceutical Chemistry'},
{listName:'Pharmacognosy'},
{listName:'State-of-the-Art Infrastructure - •	MVN provides access to well-equipped laboratories, modern classrooms and advanced simulation tools to ensure experiential learning in a real-world setting.'},
{listName:'Experienced Faculty - •	Our team of highly qualified faculty members bring a wealth of academic knowledge and industry expertise, guiding students toward excellence in the pharmacy profession.'},
{listName:'3. Career & Higher Education Opportunities'},
{listName:'Candidates of the D. Pharmacy program can pursue:'},
{listName:'Registration as a licensed pharmacist.'},
{listName:'Employment in hospitals, retail pharmacies, pharmaceutical companies and regulatory agencies.'},
{listName:'Advanced studies such as B. Pharmacy or other allied health sciences.'},
    
    ]
    const feeStructureData=[
        {duration:'1st Year Onwards Fees','2 Years':'₹90000/- (Tuition Fee - ₹70000 + Other Charges- ₹20000/-)'},
        // {duration:'2nd Year Onwards Fees','2 Years':'₹87000/- ( Tuition Fee – ₹70000 + Other Charges- ₹20000/-)'}
    ]
    const hostalFeeData=[
        {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='2 years'
    const fee_1st= '90,000'
    const fee_2nd= '90,000'
    const eligibility='Pass in 10+2 examination (science academic stream) with Physics, Chemistry and Biology or Mathematics or Any other qualification approved by the Pharmacy Council of India as equivalent to the above examination.'
return (
<Grid container spacing={2}>
<Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid>
<Grid item xs={12}>
    <MainTitle title="D. Pharmacy" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="About the Program" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The Diploma in Pharmacy program at MVN University in Haryana sounds like an exciting opportunity for aspiring Pharmacists. The emphasis on academic excellence and industry relevance suggests that students will receive a well-rounded education that prepares them for the challenges of the field. Having experienced faculty members and state-of-the-art facilities can greatly enhance the learning experience and ensure that students have access to the latest resources and technologies in the field of Pharmacy. This program seems like a great choice for anyone looking to pursue a career in Pharmacy due to tenure of two years. It serves as a fundamental platform for individuals aspiring to pursue a career in the Pharmaceutical industry. It equips students with essential knowledge and skills in Pharmaceutical sciences, including Pharmacology, Pharmaceutics, Pharmacognosy, and Pharmaceutical chemistry. One of the significant advantages of this program is its emphasis on practical training, which allows students to gain hands-on experience in various aspects of Pharmacy practice. The candidates after completion of D. Pharmacy are expected to attain the professional competencies like review Prescriptions, dispense prescription / non-prescription medicines, provide patient counselling / education, hospital and community pharmacy management, expertise on medications, proficiency on drugs / Pharmaceuticals, entrepreneurship and leadership, deliver primary and preventive healthcare, professional, ethical and legal practice and continuing professional development. 
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Eligibility" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
    Minimum Eligibility Criteria <br/><br/>
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Pass in 10+2 examination (science academic stream) with Physics, Chemistry and Biology or Mathematics or Any other qualification approved by the Pharmacy Council of India as equivalent to the above examination.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Programme Highlights" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={progHiglight}/>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Fee Structure" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The comprehensive fee structure is designed to be transparent, helping you and your family plan effectively for all four years of the program. Below, you will find a detailed breakdown of tuition fees, including specific costs for the first year and subsequent years.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    D. Pharmacy
    </Typography>
    <TableDataPresentation data={feeStructureData}/>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Ensure your comfort and convenience while studying at our institution with our range of hostel accommodations. We offer various options to suit your preferences, including triple seater rooms, both air-conditioned and non-air-conditioned, complete with meal plans. Below, you’ll find detailed information on our hostel fee structures for each option.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable) <br/><br/>
    </Typography>
    </Grid>
    </Grid>

)
}
export default DPharma;